import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { FeedbackModal } from '@/components/feedback/FeedbackModal'
import { NavbarAccountActions } from '@/components/navbar/NavbarAccountActions'
import PriorityNav from '@/components/navbar/PriorityNav'
import { Button } from '@/components/ui'
import { useLogout } from '@/hooks/auth/useLogout'
import { useTheme } from '@/hooks/ui/useTheme'
import { useAuthStore } from '@/store/authStore'

export default function Navbar() {
  const { isAuthenticated } = useAuthStore()
  const { theme, toggleTheme, ThemeIcon } = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const logoutMutation = useLogout()

  const handleLogout = async () => {
    await logoutMutation.mutateAsync()
    navigate('/login')
  }

  return (
    <>
      <nav className="bg-elevated sticky top-0 z-40" aria-label="Primary">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 md:h-16 gap-4">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center space-x-2 flex-shrink-0"
              aria-label="TreasureLog home"
              aria-current={location.pathname === '/' ? 'page' : undefined}
            >
              <span className="text-2xl" aria-hidden="true">
                🏴‍☠️
              </span>
              <span className="text-xl font-bold text-primary hidden sm:inline">TreasureLog</span>
            </Link>

            {/* Priority navigation */}
            <PriorityNav />

            {/* Auth buttons - always visible */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                variant="ghost"
                size="icon"
                onClick={toggleTheme}
                className="hidden md:inline-flex"
                title={`Theme: ${theme}`}
                aria-label={`Toggle theme (current: ${theme})`}
                icon={<ThemeIcon className="w-5 h-5" />}
              />
              <NavbarAccountActions onOpenFeedback={() => setFeedbackOpen(true)} onLogout={handleLogout} />
            </div>
          </div>
        </div>
      </nav>
      {isAuthenticated && <FeedbackModal isOpen={feedbackOpen} onClose={() => setFeedbackOpen(false)} />}
    </>
  )
}
